/**
 * FileAuditLog — thin wrapper around the unified AuditLogPanel.
 */
import React from 'react';
import AuditLogPanel from '../AuditLog/AuditLogPanel';

interface FileAuditLogProps {
  entityType: string;
  entityId: string;
  entityName?: string;
  onClose: () => void;
}

const FileAuditLog: React.FC<FileAuditLogProps> = ({ entityType, entityId, entityName, onClose }) => (
  <AuditLogPanel
    entityType={entityType}
    entityId={entityId}
    entityName={entityName}
    onClose={onClose}
  />
);

export default FileAuditLog;
